import { styled } from '@mui/material';
import Section1 from './Section1';
import Section2 from './Section2';
import Section3 from './Section3';
import Section4 from './Section4';
import Section5 from './Section5';
import Section6 from './Section6';
import Section7 from './Section7';
import Section8 from './Section8';
import Section9 from './Section9';

const HeroSection = styled('section')(({ theme }) => ({
  background: 'url("https://bucket.ywhdev.com/wl/?id=fn5iy14kte65nRKogiqcA5Yqj6t1oFmu&fmode=open")',
  overflow: 'hidden',
  height: 700,
  alignItems: 'flex-end',
  display: 'flex',
  justifyContent: 'center',
  paddingBottom: 80,
  position: 'relative',
  backgroundPosition: 'center',
  backgroundSize: 'cover',
  borderBottom: '8px solid #5284e0',
  gap: 8,
  textAlign: 'center',
  '& div.header': {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    h1: {
      color: 'white',
      fontFamily: 'Playfair Display',
      zIndex: 2,
      fontSize: 48,
      lineHeight: '60px',
      fontWeight: 700,
    },
    h3: {
      color: '#CDA07D',
      zIndex: 2,
      fontSize: 24,
      lineHeight: '36px',
      fontWeight: 600,
    },
  },
}));

const Content = styled('section')(({ theme }) => ({
  padding: '80px 0',
  paddingBottom: 0,
  display: 'flex',
  flexDirection: 'column',
  gap: 80,
}));

const MarketingYourHome = () => {
  return (
    <div className="marketing-your-home">
      <HeroSection>
        <div className="header">
          <h1>Marketing Your Home</h1>
          <h3>Tools for a successful sale</h3>
        </div>
      </HeroSection>
      <Content>
        <Section1 />
        <Section2 />
        <Section3 />
        <Section4 />
        <Section5 />
        <Section6 />
        <Section7 />
        <Section8 />
      </Content>
      <Section9 />
    </div>
  );
};

export default MarketingYourHome;
